$(document).ready(function()
{

    $(".slick-standard").slick({
        dots: false,
        arrows: true,
        autoplay: false,
        variableWidth: false,
        //autoplaySpeed: 5000,
    });

    var cards = $('.slick-cards .card');
    var maxHeight = 0;

    if (cards)
    {
        // Loop all cards and check height, if bigger than max then save it
        for (var i = 0; i < cards.length; i++) 
        {
            if (maxHeight < $(cards[i]).outerHeight()) 
            {
                maxHeight = $(cards[i]).outerHeight();
            }
        }
        // Set ALL card bodies to this height
        for (var i = 0; i < cards.length; i++) 
        {
            $(cards[i]).height(maxHeight);
        }
    }

});

// slick changes on resize
$(window).on('load resize orientationchange', function() 
{
    $('.slick-on-small').each(function(){
        var $carousel = $(this);

        if ($(window).width() > 640) 
        {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else
        {
            if (!$carousel.hasClass('slick-initialized')) 
            {
                $carousel.slick({
                  dots: true,
                  arrows: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false,
                  //autoplay: true,
                  pauseOnHover:true,
                  pauseOnFocus: false,
                  autoplaySpeed: 5000,
                });
            }
        }
    });

});